import {
    Avatar,
    Button,
    ButtonGroup,
    Collapse,
    Divider,
    InputAdornment,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    makeStyles,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core"
import { useEffect, useRef, useState } from "react"
import icon99 from "../../../assets/99-app-logo-0.png"
import iconIfood from "../../../assets/ifood-logo.png"
import {
    AlterarShopStatus99Food,
    AtualizarDetalhesLoja,
    ObterStatusLoja99,
} from "../../../services/99food"
import useAppStore from "../../../stores/AppStore"
import { UberLogo } from "../IntegracaoUber/assets"

const useStyles = makeStyles(theme => ({
    botao: {
        color: "#5f5f5f",
    },
    listaIntegracoes: {
        backgroundColor: "#fff",
        position: "absolute",
        zIndex: 5,
    },
    lista: {
        padding: "4px",
        display: "flex",
        flexDirection: "column",
        "& > li": {
            flex: "1 0 100px",
        },
        "& > li > imagem": {
            height: "100%",
        },
    },
    itemLista: {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "175px",
        padding: 0,
        "& p": { margin: "0.125rem 0.25rem", borderBottom: "1px black solid" },
        "& p:last-child": {
            borderBottom: "none",
        },
    },
    botaoIfood: {
        width: "100%",
        height: "100%",
        padding: "1.25rem 0",
    },
    botaoUber: {
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
    },
}))

export default function ListaIntegracoes({
    estabelecimentos,
    expandListaIntegracoes,
    setExpandListaIntegracoes,
    statusLojaIfood,
    statusLoja99,
}) {
    const classes = useStyles()

    const configuracoes = useAppStore(s => s.configuracoes)

    const [posicaoBotao, setPosicaoBotao] = useState({})
    const [posicaoPainel, setPosicaoPainel] = useState(150)
    const [openPaperIfood, setOpenPaperIfood] = useState(false)
    const [openPaper99, setOpenPaper99] = useState(false)
    const [data99, setData99] = useState([])

    const integradoComUber = configuracoes.user?.parametros?.possuiIntegracaoUber
    const integradoComIfood = configuracoes.user?.parametros?.ativaIntegracaoIfood
    const integradoCom99 = true //Trocar pelo parâmetro real quando ele for criado

    const verificarStatusLoja99 = async () => {
        try {
            // TODO: PRECISA FAZER ISSO PRA TODAS?
            console.log("asdasd retorno99 antes", estabelecimentos)

            const shopStatuses = []

            estabelecimentos.forEach(async estab => {
                try {
                    const retorno = await ObterStatusLoja99(estab.id)

                    shopStatuses.push(retorno)
                } catch (error) {}
            })

            console.log("asdasd retorno99", shopStatuses)

            setData99(shopStatuses)
        } catch (error) {
            console.log("err: " + error)
        }
    }
    useEffect(() => {
        setPosicaoBotao(document.getElementById("botao-lista-integracoes")?.getBoundingClientRect())

        if (expandListaIntegracoes && integradoCom99) verificarStatusLoja99()
    }, [expandListaIntegracoes])

    useEffect(() => {
        if (document.getElementById("painel-integracoes")) {
            const widthPainel = document
                .getElementById("painel-integracoes")
                ?.getBoundingClientRect().width
            let pos =
                window.screen.width > 600 ? posicaoBotao.right - widthPainel : posicaoBotao.left
            setPosicaoPainel([pos, posicaoBotao.bottom])
        }
    }, [posicaoBotao])

    const timerTempoDePreparoRef = useRef(undefined)

    if (!integradoComUber && !integradoComIfood) return null

    return (
        <Collapse
            in={expandListaIntegracoes}
            id="painel-integracoes"
            className={classes.listaIntegracoes}
            style={{ left: posicaoPainel[0], top: posicaoPainel[1] }}
        >
            <Paper elevation={4}>
                <List className={classes.lista}>
                    {integradoComUber && (
                        <>
                            <ListItem className={classes.itemLista}>
                                <Button className={classes.botaoUber}>
                                    <UberLogo height={50} />
                                </Button>
                            </ListItem>
                            <Divider style={{ height: "2px" }} />
                        </>
                    )}
                    {integradoComIfood && (
                        <>
                            <ListItem className={classes.itemLista}>
                                <Button
                                    className={classes.botaoIfood}
                                    onClick={() => setOpenPaperIfood(prev => !prev)}
                                >
                                    <img src={iconIfood} height={58} alt="iFood Integração" />
                                </Button>
                                {openPaperIfood && (
                                    <Paper elevation={4}>
                                        {statusLojaIfood?.message && (
                                            <Typography variant="body2">
                                                {statusLojaIfood?.message}
                                            </Typography>
                                        )}
                                        {statusLojaIfood?.extraInfo?.map(info => (
                                            <Typography variant="body2">{info}</Typography>
                                        ))}
                                    </Paper>
                                )}
                            </ListItem>
                            {integradoComIfood && integradoCom99 && (
                                <Divider style={{ height: "2px" }} />
                            )}
                        </>
                    )}
                    {integradoCom99 && (
                        <ListItem className={classes.itemLista}>
                            <Button
                                className={classes.botaoIfood}
                                onClick={() => setOpenPaper99(prev => !prev)}
                            >
                                <img src={icon99} height={58} alt="iFood Integração" />
                            </Button>
                            <Collapse in={openPaper99} mountOnEnter>
                                <Paper elevation={4}>
                                    <List>
                                        {data99.map(data => {
                                            const isAberto = data.biz_status === 1

                                            return (
                                                <ListItem
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <div style={{ display: "flex" }}>
                                                        <ListItemAvatar>
                                                            <Avatar src={data.logo_img} />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={data.name}
                                                            secondary={
                                                                data.biz_status === 1
                                                                    ? "Aberto"
                                                                    : "Fechado"
                                                            }
                                                        />
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            gap: "2rem",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <TextField
                                                            defaultValue={
                                                                data.promise_produce_time / 60
                                                            }
                                                            label="Tempo de preparo"
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        min
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            onChange={e => {
                                                                e.persist()

                                                                if (timerTempoDePreparoRef.current)
                                                                    clearTimeout(
                                                                        timerTempoDePreparoRef.current
                                                                    )

                                                                timerTempoDePreparoRef.current =
                                                                    setTimeout(() => {
                                                                        AtualizarDetalhesLoja(
                                                                            {
                                                                                promise_produce_time:
                                                                                    Number(
                                                                                        e.target
                                                                                            .value
                                                                                    ) * 60,
                                                                            },
                                                                            configuracoes.user
                                                                                .parametros
                                                                                .estabelecimento.id
                                                                        )
                                                                    }, 1000)
                                                            }}
                                                        />
                                                        <ButtonGroup>
                                                            <Button
                                                                variant={
                                                                    isAberto
                                                                        ? "contained"
                                                                        : "outlined"
                                                                }
                                                                style={{
                                                                    backgroundColor: isAberto
                                                                        ? "#14A44D"
                                                                        : "white",
                                                                    color: isAberto
                                                                        ? "white"
                                                                        : "black",
                                                                    fontSize: "9px",
                                                                }}
                                                                onClick={() => {
                                                                    AlterarShopStatus99Food({
                                                                        biz_status: 1,
                                                                        auto_switch: 3,
                                                                    })
                                                                }}
                                                            >
                                                                Aberto
                                                            </Button>
                                                            <Button
                                                                variant={
                                                                    !isAberto
                                                                        ? "contained"
                                                                        : "outlined"
                                                                }
                                                                style={{
                                                                    backgroundColor: !isAberto
                                                                        ? "#DC4C64"
                                                                        : "white",
                                                                    color: !isAberto
                                                                        ? "white"
                                                                        : "black",
                                                                    fontSize: "9px",
                                                                }}
                                                                onClick={() => {
                                                                    AlterarShopStatus99Food({
                                                                        biz_status: 2,
                                                                        auto_switch: 3,
                                                                    })
                                                                }}
                                                            >
                                                                Fechado
                                                            </Button>
                                                        </ButtonGroup>
                                                    </div>
                                                </ListItem>
                                            )
                                        })}
                                    </List>
                                </Paper>
                            </Collapse>
                        </ListItem>
                    )}
                </List>
            </Paper>
        </Collapse>
    )
}
